export class SessionViewModelDelegate {
    allSessionsDisconnected: ((...args: any[]) => void) | null = null;
    onCredentialsNeeded: ((...args: any[]) => void) | null = null;
    onTrustChallenge: ((...args: any[]) => void) | null = null;
    openLoaderModal: ((...args: any[]) => void) | null = null;
    closeLoaderModal: ((...args: any[]) => void) | null = null;
    openAutoreconDialog: ((...args: any[]) => void) | null = null;
    closeAutoreconDialog: ((...args: any[]) => void) | null = null;
    sessionTakeFocus: ((...args: any[]) => void) | null = null;
    showToast: ((...args: any[]) => void) | null = null;
    showCopyConfirmationDialog: ((...args: any[]) => void) | null = null;
    showClipHelptip: ((...args: any[]) => void) | null = null;
    showNoGatewayError: ((...args: any[]) => void) | null = null;
}
